var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17C24 17 26 19 26 21.5C26 22.38 25.75 23.21 25.31 23.9L28.39 27L27 28.39L23.88 25.32C23.19 25.75 22.37 26 21.5 26C19 26 17 24 17 21.5C17 19 19 17 21.5 17ZM21.5 19C20.837 19 20.2011 19.2634 19.7322 19.7322C19.2634 20.2011 19 20.837 19 21.5C19 22.163 19.2634 22.7989 19.7322 23.2678C20.2011 23.7366 20.837 24 21.5 24C22.163 24 22.7989 23.7366 23.2678 23.2678C23.7366 22.7989 24 22.163 24 21.5C24 20.837 23.7366 20.2011 23.2678 19.7322C22.7989 19.2634 22.163 19 21.5 19ZM16 9C17.0609 9 18.0783 9.42143 18.8284 10.1716C19.5786 10.9217 20 11.9391 20 13C20 13.91 19.69 14.75 19.18 15.43C18.32 15.75 17.55 16.26 16.91 16.9L16 17C14.9391 17 13.9217 16.5786 13.1716 15.8284C12.4214 15.0783 12 14.0609 12 13C12 11.9391 12.4214 10.9217 13.1716 10.1716C13.9217 9.42143 14.9391 9 16 9ZM8 25V23C8 20.88 11.31 19.14 15.5 19C15.18 19.78 15 20.62 15 21.5C15 22.79 15.38 24 16 25H8Z",
    fill: "url(#paint0_linear_3872_1267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1267",
    x1: 18.195,
    y1: 9,
    x2: 18.195,
    y2: 28.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchId);
export default __webpack_public_path__ + "static/media/searchID.0bb46b20b32a395a671529fbc9be8c7f.svg";
export { ForwardRef as ReactComponent };